<template>
  <el-tooltip
    placement="top"
    effect="light"
    :disabled="flag" class="linepopperClass">
    <div class="text-wrapper" slot="content">
      {{content}}
    </div>
    <div :class="{'wrap_one': isEnableDownload}" >
      <i :ref="`content${index}`" style="font-style: normal;">{{content}}</i>
    </div>
  </el-tooltip>
</template>
<script>
export default {
  props: {
    widths: {
      default: 0,
      type: Number,
    },
    index:{
      default: 0,
      type: Number,
    },
    content:{
      default:'',
      type:String
    },
    isEnableDownload:{
      default: true,
      type: Boolean,
    },
  },
  data() {
    return {
      flag:false,
    }
  },
  methods: {
    overWidth(index){
      this.$nextTick(() => {
        const contentwidth = this.$refs[`content${index}`];
        // 此处500和 max-width属性的值同步
        if (contentwidth.offsetWidth > this.widths) {
          this.flag = false;
        } else if (contentwidth.offsetWidth <= this.widths) {
          this.flag = true;
        }
      });
    },
  },
  mounted() {
    this.overWidth(this.index);
  },
}
</script>
<style lang="scss" scoped>
.wrap_one{
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  line-height: 18px;
  cursor: pointer;
  >i:hover{
    text-decoration: underline;
    color: #066EB7;
  }
}
</style>
<style lang="scss">
.linepopperClass{
  // .el-tooltip_popper[x-placement^=] .popper_arrow{
  //   border-top-color: #ebeef5 !important;
  // }
  //箭头颜色
.el-tooltip__popper[x-placement^=top] .popper__arrow::after {
  border-left-color: red;
  }

.el-tooltip__popper[x-placement^=top] .popper__arrow{
  border-left-color: red;
  }
}
</style>